/* eslint-disable */

export default {
  default: {
    h1Text: 'Kinderleicht zu verarbeitende Flachdachabdichtung',
    leadText: 'Inklusive 5 Jahre Gewährleistung',
    objectText: 'Flachdach'
  },
  'angebot-1': {
    h1Text: 'Kinderleicht zu verarbeitende Flachdachabdichtung',
    leadText: 'Jetzt Angebot nutzen und 20% sparen',
    objectText: 'Flachdach'
  },
  'garagendach abdichten': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'garagendach sanieren': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'garagendach abdichten flüssigkunststoff': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserem EASY Flüssigkunststoff wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'flachdachabdichtung garage': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'terrassenabdichtung': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terrasse abdichten': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terrassenabdichtung mit flüssigkunststoff': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'dachterrasse abdichten': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terrassenabdichtung flüssigkunststoff preise': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'flüssigabdichtung terrasse': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terasse abdichten': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'carport dach abdichten': {
    h1Text: 'Carport abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Carport wieder dicht!',
    objectText: 'Carport'
  },
  'balkonabdichtung': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'flüssigkunststoff balkon': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'balkon abdichten': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'flüssigkunststoff balkon test': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'dachabdichtung': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dach abdichten': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssige dachabdichtung': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dachabdichtung flüssigkunststoff': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dachabdichtung flüssig': {
    h1Text: 'Flüssige Dachabdichtung',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssigkunststoff dachabdichtung': {
    h1Text: 'Flüssige Dachabdichtung',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssigkunststoff dach kaufen': {
    h1Text: 'Flüssige Dachabdichtung',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dachdicht': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'holzdach abdichten': {
    h1Text: 'Holzdach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Holzdach'
  },
  'dach beschichten': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssigkunststoff balkon test': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'flachdachabdichtung': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach abdichten': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flüssigkunststoff dach': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flüssigabdichtung': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach abdichtung': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach abdichten flüssigkunststoff': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'dachabdichtung flachdach': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach sanieren': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flüssigkunststoff flachdach': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach abdichten flüssig': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flüssigkunststoff für flachdach kaufen': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'abdichtung flachdach': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flüssigkunststoff flachdach preis': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach abdichten': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdachabdichtung flüssigkunststoff': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdach flüssigkunststoff': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'flachdachsanierung mit flüssigkunststoff': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'alfa easy flachdachabdichtung': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  },
  'easy flachdachabdichtung 1k': {
    h1Text: 'Flachdach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
    objectText: 'Flachdach'
  }
}



// WEBPACK FOOTER //
// ./src/content/flachdach.js